module.exports = __webpack_public_path__ + "img/bookmark-plus.204bbdfb.svg";